﻿var angular = require('angular');

// @ngInject
var app = angular.module('MailSubApp', [

        //libraries
        require('angular-route'),
        require('angular-animate'),
        require('angular-translate')
])

    //constants
    .constant('cfg', { appVer: require('../package.json').version })
    .constant("LANGS", [
        require('./langs/en.js'),
        require('./langs/de.js'),
        require('./langs/fr.js'),
        require('./langs/ar.js'),
        require('./langs/da.js'),
        require('./langs/fi.js'),
        require('./langs/no.js'),
        require('./langs/id.js'),
        require('./langs/sc.js'),
        require('./langs/sv.js'),
        require('./langs/tc.js'),
        require('./langs/th.js')
])
    //controllers
    .controller('aboutCtrl', require('./controllers/aboutCtrl'))
    .controller('unsubscribeCtrl', require('./controllers/unsubscribeCtrl'))
    .controller('resubscribeCtrl', require('./controllers/resubscribeCtrl'))

    //services
    .factory('subscriberSvc', require('./services/subscriberSvc'))
    .factory("traceSvc", require('./services/traceSvc'))
    .factory("appLogSvc", require('./services/appLogSvc'))
    .factory("errorLogSvc", require('./services/errorLogSvc'))

    //providers
    .provider('$exceptionHandler', {
        $get: function (errorLogSvc) {
            return (errorLogSvc);
        }
    })



    //routes
    // @ngInject
    .config(function ($routeProvider, $locationProvider, $translateProvider, LANGS) {
        $locationProvider.html5Mode(true);
        console.log(LANGS, 'LANGS');

        $routeProvider
            .when("/", { templateUrl: "/app/views/invalid.html" })
            .when("/invalid", { templateUrl: "/app/views/invalid.html" })
            .when("/about", { templateUrl: "/app/views/about.html", controller: 'aboutCtrl' })
            .when("/unsubscribe", { templateUrl: "/app/views/unsubscribe.html", controller: 'unsubscribeCtrl' })
            .when("/resubscribe", { templateUrl: "/app/views/resubscribe.html", controller: 'resubscribeCtrl' })
            .otherwise({ redirectTo: "/" });


        //Register languages with translation provider using LANGS constant
        var langKeys = [];
        var langMappings = {};

        for (i = 0; i < LANGS.length; i++) {
            var lang = LANGS[i];
            var langId = lang.id;

            $translateProvider.translations(langId, lang.translations);
            langKeys.push(langId);
            langMappings[langId + '_*'] = langId;
        }

        //Add fallback language
        langMappings['*'] = 'en';

        //Configure translation provider
        $translateProvider
            .useSanitizeValueStrategy('escapeParameters')
            .registerAvailableLanguageKeys(langKeys, langMappings)
            .determinePreferredLanguage()
            .fallbackLanguage('en');
    })
  .run(function ($rootScope, $location, $translate, LANGS, appLogSvc) {
      $rootScope.$on("$routeChangeStart", function () {
          appLogSvc.log('navigate: ' + $location.url());
      });

      $rootScope.selectLang = function (langKey) {

          appLogSvc.log('switching to ' + langKey);
          $translate.use(langKey);

          //set lang rtl
          for (var i = 0; i < LANGS.length; i++) {
              var lang = LANGS[i];
              if (lang.id === langKey) {
                  $rootScope.langRtl = lang.rtl;
              }
          }

          if ($rootScope.langKey !== langKey) {
              $rootScope.langKey = langKey;
          };
      };
    

      $rootScope.langs = LANGS;
      $rootScope.selectLang($translate.use()); //init var to lang determined by browser settings

      //Force default language for testing
      //$rootScope.selectLang('de');
  });

